<template>
  <div class="handleRefund">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
      :before-close="handleClose"
    >
      <div class="alert_box">
        <el-alert
          title="注：处理学员退费需原支付金额完整退回，不可收取服务费等附加费用；"
          :closable="false"
          type="info"
        >
        </el-alert>
      </div>

      <div class="title"><span class="title_inside"></span>工单信息</div>
      <el-form :model="refundData" label-width="120px">
        <el-form-item label="退费原因">
          <span v-if="refundData.reason === 1">个人原因</span>
          <span v-else-if="refundData.reason === 2">其他</span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="退款方式">
          <span v-if="refundData.refundWay === 1">原路退回</span>
          <span v-else-if="refundData.refundWay === 2">指定账号</span>
          <span v-else>--</span>
        </el-form-item>
        <template v-if="refundData.refundWay === 2">
          <el-form-item label="收款人姓名">
            {{ refundData.payeeName || "--" }}
          </el-form-item>
          <el-form-item label="开户行名">
            {{ refundData.receiveBank || "--" }}
          </el-form-item>
          <el-form-item label="开户地区">
            {{
              refundData.branchBankProvice + "--" + refundData.branchBankCity
            }}
          </el-form-item>
          <el-form-item label="开户支行">
            {{ refundData.branchBank || "--" }}
          </el-form-item>
          <el-form-item label="银行卡号" prop="bankNo">
            {{ refundData.bankNo || "--" }}
          </el-form-item>
        </template>
        <el-form-item label="退费金额">
          {{ orderData.payAmt || "--" }}
        </el-form-item>
        <el-form-item label="发票处理方式">
          <span v-if="refundData.billWay === 0">未开发票</span>
          <span v-else-if="refundData.billWay === 1">电子发票注销</span>
          <span v-else-if="refundData.billWay === 2">纸质发票退回</span>
          <span v-else-if="refundData.billWay === 3">纸质发票丢失</span>
          <span v-else-if="refundData.billWay === 4">纸质发票已扣税点</span>
          <span v-else-if="refundData.billWay === 5">其他</span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="备注">
          {{ refundData.remarks || "--" }}
        </el-form-item>
        <el-form-item label="凭证">
          <div class="flx">
            <div
              class="flx_inner"
              v-for="(item, index) in refundData.voucherImg"
              :key="index"
            >
              <el-image
                style="width: 80px; height: 80px"
                :src="item"
                :preview-src-list="[item]"
              >
              </el-image>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <el-form
        ref="formInline"
        :rules="rules"
        :model="formInline"
        label-width="120px"
      >
        <div class="title"><span class="title_inside"></span>打款时间</div>
        <el-form-item label="打款时间" prop="refundTime">
          <!-- v-if="status === 'handle'" -->
          <el-date-picker
            v-model="formInline.refundTime"
            type="datetime"
            @change="refundTimeChange"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
          <!-- <span v-else-if="status === 'details'">{{
            refundData.refundTime
          }}</span> -->
        </el-form-item>
        <div class="title"><span class="title_inside"></span>打款回执</div>
        <el-form-item label="实际收款公司">
          {{ refundData.platName || "--" }}
        </el-form-item>
        <el-form-item label="退款金额">
          {{ orderData.payAmt }}
        </el-form-item>
        <el-form-item label="">
          <PictureUpload v-model="form.payUrl" />
        </el-form-item>
        <div class="title">
          <span class="title_inside"></span>
          <span>退款回执</span>
          <span class="title_hint"
            >提示：原因多因为银行打款失败，上传退款回执时，退款状态为“打款失败”</span
          >
        </div>
        <el-form-item label="实际收款公司">
          {{ refundData.platName || "--" }}
        </el-form-item>
        <el-form-item label="退款金额">
          {{ orderData.payAmt }}
        </el-form-item>
        <el-form-item label="">
          <PictureUpload v-model="form.refundUrl" />
        </el-form-item>
      </el-form>
      <div class="title"><span class="title_inside"></span>操作日志</div>
      <template v-if="!workLogBool">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in workLogDataOne"
            :key="index"
            icon="el-icon-more"
            color="#4795f5"
            type="primary"
            size="large"
            :timestamp="activity.insertDate"
          >
            <div style="word-break: break-all">
              【{{ activity.operator }}】
              <span style="margin-right: 16px">{{ activity.operateMsg }}</span>
              <span>{{ activity.remarks }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <template v-else>
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in workLogData"
            :key="index"
            :icon="index === 0 ? 'el-icon-more' : ''"
            :color="index === 0 ? '#4795f5' : ''"
            type="primary"
            size="large"
            :timestamp="activity.insertDate"
          >
            <div style="word-break: break-all">
              【{{ activity.operator }}】
              <span style="margin-right: 16px">{{ activity.operateMsg }}</span>
              <span>{{ activity.remarks }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <div
        v-if="workLogData.length > 1"
        class="show_box"
        @click="workLogBool = !workLogBool"
      >
        {{ workLogBool ? "收起" : "展开" }}
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <template v-if="status === 'handle'"> -->
        <el-button size="small" @click="openRejectModel">驳回申请</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确定退费</el-button
        >
        <!-- </template> -->
        <el-button size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="驳回原因"
      :visible.sync="rejectModel"
      width="500px"
      :before-close="rejectClose"
    >
      <el-input
        :rows="5"
        type="textarea"
        placeholder="请输入内容"
        v-model="rejectReason"
        maxlength="2000"
        show-word-limit
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="rejectClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="rejectAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PictureUpload from "@/components/pictureUpload.vue";
import { getOrderDetail } from "@/api/orderAdmin/orderList";
import {
  saveReceiptImg,
  getRefundWorkData,
  getworkLogListPage,
  rejectRefundWorkData,
} from "@/api/refund/refundOrder.js";
import { processing } from "@/utils/handle.js";
export default {
  components: {
    PictureUpload,
  },
  data() {
    return {
      rejectReason: "",
      dialogTitle: "",
      dialogVisible: false,
      rejectModel: false,
      formInline: {
        payImageUrl: "",
        refundImageUrl: "",
        refundTime: "",
      },
      form: {
        payUrl: [],
        refundUrl: [],
      },
      rules: {
        refundTime: [
          { required: true, message: "请选择退款时间", trigger: "change" },
        ],
      },
      orderData: {},
      refundData: {},
      workLogData: [],
      workLogDataOne: [],
      workLogBool: false,
      uploadHost: "",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      status: "",
    };
  },
  methods: {
    // 确认驳回
    rejectAffirm() {
      rejectRefundWorkData({
        id: this.refundData.id,
        rejectReason: this.rejectReason,
      }).then((res) => {
        if (res.code === 0) {
          this.$parent.refresh();
          this.$message({
            message: "驳回成功",
            type: "success",
          });
          this.rejectModel = false;
          this.dialogVisible = false;
        }
      });
    },
    // 打开驳回弹窗
    openRejectModel() {
      this.rejectReason = "";
      this.rejectModel = true;
    },
    // 取消驳回
    rejectClose() {
      this.rejectModel = false;
    },
    refundTimeChange(payload) {
      this.formInline.refundTime = payload;
    },
    // 初始化
    init(status, payload) {
      Object.assign(this.$data, this.$options.data());
      this.status = status;
      this.dialogTitle = status === "handle" ? "处理退费" : "退费处理详情";
      this.asyncApiMeth(payload).then((res) => {
        this.refundData = res[0].data || {};
        Object.keys(this.formInline).forEach((key) => {
          this.formInline[key] = res[0]?.data[key] || "";
        });

        if (this.formInline.payImageUrl !== "") {
          this.form.payUrl = [
            { name: "图片1", url: this.formInline.payImageUrl },
          ];
        }

        if (this.formInline.refundImageUrl !== "") {
          this.form.refundUrl = [
            { name: "图片1", url: this.formInline.refundImageUrl },
          ];
        }

        this.refundData.voucherImg = this.refundData.voucherImg
          ? this.refundData?.voucherImg?.split(",")
          : [];
        this.orderData = res[1].data || {};
        this.workLogData = res[2].data?.records || [];
        if (res[2].data?.records?.length > 0) {
          this.workLogDataOne = [res[2].data?.records[0]] || [];
        }
      });
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    asyncApiMeth(payload) {
      const refundWorkData = getRefundWorkData({ id: payload.id });
      const orderDetailData = getOrderDetail({ orderId: payload.orderId });
      const workLogData = getworkLogListPage({
        page: 1,
        limit: -1,
        workDataId: payload.id,
      });
      return Promise.all([refundWorkData, orderDetailData, workLogData]);
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      if (!this.formInline.refundTime) {
        this.$message({
          message: "请完善打款时间",
          type: "warning",
        });
        return;
      }
      if (this.form.payUrl.length < 1) {
        this.$message({
          message: "请完善打款回执",
          type: "warning",
        });
        return;
      }

      let params = {
        id: this.refundData.id,
        refundTime: this.formInline.refundTime,
        payUrl: this.form.payUrl,
        refundUrl: this.form.refundUrl,
      };

      if (params.payUrl.length > 0) {
        params.payImageUrl = params.payUrl[0].url;
      }

      if (params.refundUrl.length > 0) {
        params.refundImageUrl = params.refundUrl[0].url;
      }

      delete params.payUrl;
      delete params.refundUrl;

      this.$confirm("是否确认退费?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          saveReceiptImg(processing(params)).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                message: "退费成功",
                type: "success",
              });
              this.dialogVisible = false;
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.handleRefund {
  ::v-deep .el-dialog__body {
    padding: 16px 40px 30px 30px;
  }
  .alert_box {
    margin-bottom: 20px;
  }
  .title {
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    margin-left: 2px;
    .title_inside {
      display: inline-block;
      width: 4px;
      height: 18px;
      background: #4795f5;
      margin-right: 6px;
    }
    .title_hint {
      font-size: 14px;
      margin-left: 20px;
      color: #8c939d;
    }
  }
  .show_box {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    padding: 8px 0;
    font-size: 14px;
    margin-bottom: 30px;
    background-color: #ffffff;
  }
  .show_box:hover {
    background-color: #f9fafc;
  }
  .blue_Box {
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }

  .flx {
    display: flex;
    flex-wrap: wrap;
    .flx_inner {
      margin: 0 6px;
    }
  }

  .class-upload {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:hover {
        border-color: #409eff;
      }
    }
    .upload-ploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
    }
    .class-image {
      width: 120px;
      height: 120px;
      display: block;
    }
  }
}
</style>
